var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIncomingPhoneIcon = function SvgIncomingPhoneIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M0 0h34v34H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m4.729 5.992 1.88-1.88a3.187 3.187 0 0 1 4.507 0l3.457 3.457a3.19 3.19 0 0 1 .676 3.51l-1.512 3.525.118.31a13.1 13.1 0 0 0 7.34 7.351l.327.125 3.528-1.511a3.19 3.19 0 0 1 3.35.528l.159.148 3.455 3.455a3.187 3.187 0 0 1 0 4.507l-1.88 1.88a5.29 5.29 0 0 1-5.42 1.275l-.492-.168a33.64 33.64 0 0 1-20.78-21.13l-.078-.257A5.29 5.29 0 0 1 4.73 5.992m8.342 3.08L9.612 5.615a1.06 1.06 0 0 0-1.502 0l-1.88 1.88a3.15 3.15 0 0 0-.824 3.036l.06.2a31.5 31.5 0 0 0 19.451 19.765l.477.163a3.17 3.17 0 0 0 3.237-.765l1.88-1.88a1.06 1.06 0 0 0 0-1.501l-3.456-3.456a1.06 1.06 0 0 0-1.17-.225l-4.278 1.834-.383-.128a15.24 15.24 0 0 1-9.505-9.261l-.261-.75 1.837-4.285c.17-.4.081-.863-.226-1.17m16.993-4.509 1.503 1.503-7.748 7.746h4.87v2.125h-8.5v-8.5h2.124v4.876z",
    clipRule: "evenodd"
  })));
};
export default SvgIncomingPhoneIcon;